import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/types";
import { downloadCampaignStatusCsv } from "../api/downloadCampaignStatusCsv/downloadCampaignStatusCsvApi";
import { DownloadCampaignStatusCsvParams } from "../api/downloadCampaignStatusCsv/types";
import { downloadFile } from "@/utils/downloadFile";

interface DownloadCsvState {
  loading: boolean;
  error: string | null;
}

const initialState: DownloadCsvState = {
  loading: false,
  error: null,
};

const campaignStatusDownloadCsvSlice = createSlice({
  name: "campaignStatusDownloadCsv",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setLoading, setError } = campaignStatusDownloadCsvSlice.actions;

export const downloadCampaignStatusCsvAction =
  (params: DownloadCampaignStatusCsvParams): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    try {
      const blob = await downloadCampaignStatusCsv(params);
      const fileName = `campaign-status-${Date.now()}.csv`;
      downloadFile(blob, fileName);
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setError(error.message));
      } else {
        dispatch(setError("Failed to download CSV"));
      }
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  };

export default campaignStatusDownloadCsvSlice.reducer;
